import type { FormParagraphProps } from '@ksyos/design-system/dist/components/form-paragraph';
import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { FormContextProps } from '@frontend/components/elements/formContext';
import type { OmittedFormGroupFieldProps } from '@frontend/components/fields/FormGroup';
import type {
    IFormGroupFieldExtraProps,
    IFormGroupFieldProps,
} from '@frontend/components/userDataManagement/FormGroupField';
import { FormContextConsumer } from '@frontend/components/elements/formContext';
import { computeFormGroupProps } from '@frontend/components/fields/FormGroup';
import { FormGroupField } from '@frontend/components/userDataManagement/FormGroupField';

export function computeFormParagraphProps<T extends FormParagraphProps>(props: T): FormParagraphProps {
    return {
        children: props.children,
        layout: props.layout,
        size: props.size,
        whiteSpace: props.whiteSpace,
    };
}

export function FormParagraphFormGroup(props: FormParagraphProps & OmittedFormGroupFieldProps) {
    if (!props.children) {
        return null;
    }

    return (
        <FormGroup {...computeFormGroupProps(props)}>
            <FormParagraph
                style={{ wordWrap: 'break-word' }}
                {...computeFormParagraphProps(props)}
            />
        </FormGroup>
    );
}

interface IFormParagraphFieldProps {
    value: string;
}

export function FormParagraphFormGroupField(
    props: FormContextProps<IFormParagraphFieldProps & IFormGroupFieldProps & IFormGroupFieldExtraProps>
) {
    return (
        <FormGroupField {...props}>
            <FormContextConsumer {...props}>
                {(properties: any) => (
                    <FormParagraph {...computeFormParagraphProps(properties)}>{properties.value || '-'}</FormParagraph>
                )}
            </FormContextConsumer>
        </FormGroupField>
    );
}
